import CircularProgress from '@material-ui/core/CircularProgress';
import React, {
  Component,
} from 'react';
import styles from './styles.module.scss';

interface Props {
  size?: number;
}

class Spinner extends Component<Props> {
  render() {
    return (
      <div className={styles.spinnerContainer}>
        <CircularProgress size={this.props.size}/>
      </div>
    );
  }
}

export default Spinner;
